module.exports = [{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.14.3_babel-eslint@10.1.0_eslint@8.57.1__encoding@0.1.13_eslint-import-resolver_bf262ce181b71dd3f6e0e5b5df19bab5/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
